import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import {
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomDatePicker from '../../../components/CustomDatePicker';
import STRING_KEYS from '../../../language/keys';
import { DateValidationFields } from '../../../@types/Account';
import { style } from './style';

type DateRangeSelectorProps = {
  startDate: DateValidationFields,
  endDate: DateValidationFields,
  viewMode: ViewMode
  onChangeStartDate: (name: string, date: Date | string) => void,
  onChangeEndDate: (name: string, date: Date | string) => void,
  nameStartDate: string,
  nameEndDate: string,
  minEndDate?: Date,
};

const formats = {
  monthAndYear: 'dd.MM.yyyy',
};

export const DateRangeSelector = ({
  startDate,
  endDate,
  onChangeStartDate,
  onChangeEndDate,
  nameEndDate,
  nameStartDate,
  viewMode,
  minEndDate = new Date(),
}: DateRangeSelectorProps):JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Box>
      <Box sx={ style.Box.sx }>
        <LocalizationProvider dateFormats={ formats } dateAdapter={ AdapterDateFns }>
          <CustomDatePicker
            inputFormat={ formats.monthAndYear }
            label={ translate(STRING_KEYS.START_DATE_TITLE) }
            valueWithValidation={ { ...startDate, value: startDate.value ? new Date(startDate.value) : null } }
            viewMode={ viewMode }
            onAccept={ (value: Date | null) => {
              if (value instanceof Date &&
                (value as Date)?.getTime() !== new Date(startDate.value).getTime()) {
                onChangeStartDate(nameStartDate, new Date(value).toUTCString());
              }
            } }
            onChange={ (value) => {
              if (value instanceof Date &&
                (value as Date)?.getTime() !== new Date(startDate.value).getTime()) {
                onChangeStartDate(nameStartDate, new Date(value).toUTCString());
              }
            } }
          />
          <CustomDatePicker
            label={ translate(STRING_KEYS.END_DATE_TITLE) }
            inputFormat={ formats.monthAndYear }
            valueWithValidation={ { ...endDate, value: endDate.value ? new Date(endDate.value) : null } }
            minDate={ minEndDate }
            viewMode={ viewMode }
            // eslint-disable-next-line react/jsx-props-no-spreading
            onAccept={
              (value: Date | null) => {
                if (value instanceof Date && value !== new Date(endDate.value)) {
                  onChangeEndDate(nameEndDate, new Date(value).toUTCString());
                }
              }
            }
            onChange={ (value) => {
              if (value instanceof Date && value !== new Date(endDate.value)) {
                onChangeEndDate(nameEndDate, new Date(value).toUTCString());
              }
            } }
          />
        </LocalizationProvider>
      </Box>
    </Box>
  );
};

DateRangeSelector.defaultProps = {
  minEndDate: new Date(),
};
